'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsAdmin = undefined;

var _getUserInfo = require('ui-addon-upgrades/_core/common/api/getUserInfo');

var _AdminTypes = require('ui-addon-upgrades/_core/common/constants/AdminTypes');

var getIsAdmin = exports.getIsAdmin = function getIsAdmin(adminType) {
  return (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var user = _ref.user;

    if (adminType === _AdminTypes.BILLING) {
      var isBillingAdmin = user.scopes.indexOf('billing-write') !== -1;
      return isBillingAdmin;
    }

    var isHubOwner = user.scopes.indexOf('hub-owner') !== -1;
    var isJitaAdmin = user.scopes.indexOf('hub-parcel-write') !== -1;
    return isHubOwner || isJitaAdmin;
  }).catch(function () {
    return false;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/eligibility/getIsAdmin.js
// module id = 507
// module chunks = 3 4 5